<template>
    <div>
        <div :class="{'has-error': errors.has('quantity')}" v-if="activity.units === 'Hours' && !(timeEntry.activityCode === $acConstants('OUT_TRAVEL_TIME_CODE') && timeEntry.isNewTransportation)">
            <label for="quantity" class="col-sm-2 control-label">Time:</label>
            <div class="col-sm-2 margin-bottom-xs">
                <div>
                    <div class="input-group">
                        <input v-validate.disable="'required'" type="number" step="0.1" class="form-control"
                               id="quantity" name="quantity" key="quantity-hours" v-model="timeEntry.hours"
                               placeholder="How long?" min="0" :max="codeTimeLimitMax" @change="round($event)"
                               :disabled="timeEntry.isAuditEdit" />
                        <span class="input-group-addon">hrs</span>
                    </div>
                    <div class="text-warning" v-if="codeTimeLimitMessage != ''">{{ codeTimeLimitMessage }}</div>
                    <p class="text-danger" v-if="errors.has('quantity')">{{ errors.first('quantity') }}</p>
                </div>
            </div>
        </div>
        <div :class="{'has-error': errors.has('quantity')}" v-else-if="activity.units === 'Dollars'">
            <label for="quantity" class="col-sm-2 control-label">Quantity:</label>
            <div class="col-sm-2 margin-bottom-xs">
                <div>
                    <div class="input-group">
                        <span class="input-group-addon">$</span>
                        <input v-validate.disable="'required'" type="number" step="0.01" class="form-control"
                               id="quantity" name="quantity" key="quantity-dollars" v-model="timeEntry.dollars"
                               placeholder="How much?" min="0" @change="round($event,2)"
                               :disabled="timeEntry.isAuditEdit" />
                    </div>
                    <p class="text-danger" v-if="errors.has('quantity')">{{ errors.first('quantity') }}</p>
                </div>
            </div>
        </div>
        <div :class="{'has-error': errors.has('quantity')}" v-else-if="activity.units === 'Units' && !(timeEntry.activityCode === $acConstants('OUT_KILOMETRES_CODE') && timeEntry.isNewTransportation)">
            <label for="quantity" class="col-sm-2 control-label">Quantity:</label>
            <div class="col-sm-2 margin-bottom-xs">
                <div>
                    <div class="input-group">
                        <input v-validate.disable="'required'" type="number" step="1" class="form-control"
                               id="quantity" name="quantity" key="quantity-units" v-model="timeEntry.units"
                               placeholder="How many?" min="0" :max="codeTimeLimitMax" @change="round($event)"
                               :disabled="timeEntry.isAuditEdit" />
                    </div>
                    <div class="text-warning" v-if="codeTimeLimitMessage != ''">{{ codeTimeLimitMessage }}</div>
                    <p class="text-danger" v-if="errors.has('quantity')">{{ errors.first('quantity') }}</p>
                </div>
            </div>
        </div>
        <div v-if="(timeEntry.activityCode === $acConstants('OUT_KILOMETRES_CODE') || timeEntry.activityCode === $acConstants('OUT_TRAVEL_TIME_CODE')) && timeEntry.isNewTransportation">
            <!-- Time Input -->
            <label for="quantity" class="col-sm-2 control-label">Time:</label>
            <div class="col-sm-2 margin-bottom-xs" :class="{'has-error': errors.has('quantity')}">
                <div class="input-group">
                    <input v-validate.disable="'required'" type="number" step="0.1" class="form-control"
                           id="quantity" name="quantity" key="quantity-hours" v-model="timeEntry.hours"
                           placeholder="How long?" min="0" :max="codeTimeLimitMax" @change="round($event)"
                           :disabled="timeEntry.isAuditEdit" />
                    <span class="input-group-addon">hrs</span>
                </div>
                <div class="text-warning" v-if="codeTimeLimitMessage != '' && errors.has('quantity')">{{ codeTimeLimitMessage }}</div>
                <p class="text-danger" v-if="errors.has('quantity')">{{ errors.first('quantity') }}</p>
            </div>

            <!-- Distance Input -->
            <label for="distance" class="col-sm-2 col-md-1 control-label">Distance:</label>
            <div class="col-sm-2 margin-bottom-xs" :class="{'has-error': errors.has('distance')}">
                <div class="input-group">
                    <input v-validate.disable="'required'" type="number" step="1" class="form-control"
                           id="distance" name="distance" key="quantity-units" v-model="timeEntry.units"
                           placeholder="How many?" min="0" :max="codeTimeLimitMax" @change="round($event)"
                           :disabled="timeEntry.isAuditEdit" />
                    <span class="input-group-addon">KM</span>
                </div>
                <div class="text-warning" v-if="codeTimeLimitMessage != '' && errors.has('distance')">{{ codeTimeLimitMessage }}</div>
                <p class="text-danger" v-if="errors.has('distance')">{{ errors.first('distance') }}</p>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from "vue";
    import axios from 'axios';

    export default {
        inject: ['$validator'],
        data: function () {
            return {
                timeEntry: this.$store.state.timeEntry,
                codeTimeLimitMessage: "",
                codeTimeLimitMax: ""
            };
        },
        props: {
            activity: Object,
            isOutlook: Boolean
        },
        methods: {
            round(event, decimals) {
                if (event.target.value < 0) {
                    event.target.value = -1 * event.target.value;
                }
                if (decimals > 0) {
                    event.target.value = Number(event.target.value).toFixed(decimals);
                } else {
                    event.target.value = Number(Number(event.target.value).toFixed(2));
                }
            },
            // fetches time limits if any for selected activity code and the insurer
            getCodeTimeLimit() {
                let self = this;
                let branchId = this.$store.state.branchId;
                let fileId = this.$store.state.fileId;
                let code = this.timeEntry.activityCode;
                let codeTimeLimitUrl = `/core/api/claims/${branchId}/${fileId}/${code}/codeTimeLimit`;
                this.codeTimeLimitMessage = "";
                this.codeTimeLimitMax = "";
                let authHeader = "";
                if (this.isOutlook) {
                    codeTimeLimitUrl = this.$store.state.keaUrl + codeTimeLimitUrl;
                    authHeader = { headers: { "Authorization": "Bearer " + this.$store.state.accessToken } };
                }
                axios.get(codeTimeLimitUrl, authHeader)
                    .then(response => {
                        var codeTimeLimit = response.data;
                        if (codeTimeLimit.codeTimeLimitMessage != null) {
                            this.codeTimeLimitMessage = codeTimeLimit.codeTimeLimitMessage;
                            this.codeTimeLimitMax = codeTimeLimit.codeTimeLimitMax;
                        }
                    });
            }
        },
        created() {
            if (this.$store.state.fileId != 0 && this.$store.state.fileId != null && this.timeEntry.activityCode) {
                this.getCodeTimeLimit();
            }
        }
    };
</script>